module.exports = __webpack_public_path__ + "static/media/varie1.3097b92e.jpg";